// @ts-nocheck
export default {
    RESET_STORE_DETAIL(state) {
        state.storeDetail = null;
    },
    GET_STORE_DETAIL(state, payload) {
        state.storeDetail = payload;
    },
    UPDATE_DETAIL(state, payload) {
        state.storeDetail = payload;
    },
};
